<template>
  <div class="pagoda-tree-table">
    <div class="pagoda-tree-table__header" style="display: flex;">
      <div class="tree-table-col"
        v-for="({prop, label, width = defaultWidth}, idx) in head"
        :key="idx"
        :style="{width}"
      >
        <div class="cell">
          <span class="tree-table-cell">
            {{label}}
          </span>
          <span v-if="head[idx].sortable" class="caret-wrapper" @click="handleSort(prop)">
            <i class="sort-caret ascending" :class="{active: sortable.prop === prop && sortable.order === 'ascending'}" @click.stop="handleSortClick(prop, 'ascending')"></i>
            <i class="sort-caret descending" :class="{active: sortable.prop === prop && sortable.order === 'descending'}" @click.stop="handleSortClick(prop, 'descending')"></i>
          </span>
        </div>
      </div>
    </div>
    <el-tree
      class="pagoda-tree-table__body"
      :style="{
        maxHeight,
        height,
        overflowY: 'auto',
        overflowX: 'hidden'
      }"
      v-bind="$attrs"
    >
      <span slot-scope="scope" style="display: flex; flex: 1" @click.stop>
        <span class="tree-table-col"
          v-for="({prop, width = defaultWidth}, idx) in head"
          :key="idx"
          :class="`col-${idx + 1}`"
          :style="{
            width: idx === 0 ? caculateWidth(width, scope.node.level) : width,
            flex: idx === head.length - 1 && 1
          }"
        >
          <span
            class="tree-table-cell"
          >
            <slot :name="prop" v-bind="scope">
              {{scope.data[prop]}}
            </slot>
          </span>
        </span>
      </span>
    </el-tree>
  </div>
</template>

<script>

  export default {
    name: 'TreeTable',
    inheritAttrs: false,
    props: {
      head: Array,
      maxHeight: String,
      height: String,
      defaultWidth: {
        type: String,
        default: '150px'
      }
    },
    data () {
      return {
        sortable: {
          prop: '',
          order: ''
        }
      }
    },
    watch: {
      sortable: {
        deep: true,
        handler () {
          this.$emit('sort-change', this.sortable)
        }
      }
    },
    methods: {
      caculateWidth (width, level) {
        return `${parseInt(width) - 47 -(level - 1) * 18}px`
      },
      handleSort (prop) {
        const sortType = ['ascending', 'descending', '']

        if (this.sortable.prop !== prop) {
          this.sortable = {
            prop,
            order: ''
          }
        }

        let sortTypeIndex = sortType.findIndex(type => type === this.sortable.order)

        if (sortTypeIndex === sortType.length - 1) {
          sortTypeIndex = 0
        } else {
          sortTypeIndex++
        }

        this.sortable.order = sortType[sortTypeIndex]
      },
      handleSortClick (prop, order) {
        this.sortable = {
          prop,
          order
        }
      }
    }
  }
</script>